import React from "react";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import TourDates from "@/components/site/TourDates";
import Bio from "@/components/site/Bio";
import Videos from "@/components/site/Videos";
import Pictures from "@/components/site/Pictures";
import Contact from "@/components/site/Contact";
import Newsletter from "@/components/site/Newsletter";
import Footer from "@/components/site/Footer";
import "@/App.css";

function App() {
  return (
    <div className="App bg-vintage-bg text-vintage-cream min-h-screen relative overflow-x-hidden">
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            color: "#F4EFE6",
            border: "1px solid rgba(244,239,230,0.15)",
            fontFamily: "'IBM Plex Mono', monospace",
          },
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <TourDates />
        <Bio />
        <Videos />
        <Pictures />
        <Contact />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}

export default App;
